import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { type ForwardedRef, forwardRef } from 'react';
import styles from './TextLink.module.css';
import { TextLinkProps } from './types';
export type HeadlessLinkProps = Pick<TextLinkProps, 'kind' | 'className' | 'largerClickArea' | 'size'>;
export function headlessLinkProps<T extends HeadlessLinkProps>({
  kind = 'default',
  className,
  largerClickArea,
  size = 'default',
  ...props
}: T) {
  return {
    ...props,
    className: classNames(styles.link, styles[`${kind}`], className, {
      [styles.largerClickArea!]: largerClickArea,
      [styles.small as string]: size === 'small'
    })
  };
}
const TextLink = forwardRef(function TextLink(t0, ref) {
  const $ = _c(11);
  let href;
  let t1;
  if ($[0] !== t0) {
    const {
      href: t2,
      ...props
    } = t0;
    href = t2;
    t1 = headlessLinkProps(props);
    $[0] = t0;
    $[1] = href;
    $[2] = t1;
  } else {
    href = $[1];
    t1 = $[2];
  }
  let children;
  let props_;
  if ($[3] !== t1) {
    ({
      children,
      ...props_
    } = t1);
    $[3] = t1;
    $[4] = children;
    $[5] = props_;
  } else {
    children = $[4];
    props_ = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== href || $[8] !== props_ || $[9] !== ref) {
    t2 = <a ref={ref} href={href} {...props_}>{children}</a>;
    $[6] = children;
    $[7] = href;
    $[8] = props_;
    $[9] = ref;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
});
export default TextLink;